import SettingTitle from './SettingTitle';

export default SettingTitle;
